// extracted by mini-css-extract-plugin
export default {"default":"Switch_default__gmp9u","off":"Switch_off__-XTiv Switch_default__gmp9u"};